import React from 'react';

const CORPUS_TOTAL_FIELDS = [
  ['Source Records', 'sourceRecords'],
  ['Resolved Source Identities', 'resolvedSourceIdentities'],
  ['Retained Photos', 'retainedPhotos'],
  ['Indexed Faces', 'indexedFaces'],
];

export const normalizeCorpusTotals = (totals = {}) => Object.fromEntries(
  CORPUS_TOTAL_FIELDS.map(([, key]) => [key,
    Number.isSafeInteger(totals?.[key]) && totals[key] >= 0 ? totals[key] : 0]),
);

const PublicRecordCorpusTotals = ({ totals }) => {
  const current = normalizeCorpusTotals(totals);
  return (
    <section className="public-record-corpus-totals" aria-labelledby="public-record-corpus-totals-heading">
      <h3 id="public-record-corpus-totals-heading">Corpus Totals</h3>
      <dl className="ingestion-metrics">
        {CORPUS_TOTAL_FIELDS.map(([label, key]) => (
          <div key={key}><dt>{label}</dt><dd>{current[key].toLocaleString()}</dd></div>
        ))}
      </dl>
      <p>Source-local resolved identities; not necessarily globally unique people.</p>
    </section>
  );
};

export default PublicRecordCorpusTotals;
